import { createContext, useContext } from "react";

export const LegacyFrameContext = createContext<(active: boolean) => void>(() => {});

export const useSetLegacyFrameActive = () => useContext(LegacyFrameContext);
